import React, { useEffect, useState } from "react";
import { WEDDING_DATE } from "../lib/api";

const pad = (n) => String(n).padStart(2, "0");

const Countdown = ({ dark = false }) => {
  const [remain, setRemain] = useState(WEDDING_DATE - new Date());

  useEffect(() => {
    const id = setInterval(() => setRemain(WEDDING_DATE - new Date()), 1000);
    return () => clearInterval(id);
  }, []);

  const total = Math.max(0, remain);
  const days = Math.floor(total / 86_400_000);
  const hours = Math.floor((total % 86_400_000) / 3_600_000);
  const minutes = Math.floor((total % 3_600_000) / 60_000);
  const seconds = Math.floor((total % 60_000) / 1000);

  const cells = [
    { l: "Days", v: pad(days) },
    { l: "Hours", v: pad(hours) },
    { l: "Minutes", v: pad(minutes) },
    { l: "Seconds", v: pad(seconds) },
  ];

  return (
    <div data-testid="countdown" className="grid grid-cols-4 gap-3 sm:gap-5 max-w-2xl">
      {cells.map((c) => (
        <div key={c.l} className={`count-cell aspect-[3/4] flex flex-col items-center justify-center ${dark ? "bg-ink/40 border-white/20" : ""}`}>
          <div className={`font-serif text-3xl sm:text-5xl leading-none tracking-tight ${dark ? "text-ivory" : "text-ink"}`}>{c.v}</div>
          <div className={`mt-2 text-[9px] tracking-[0.3em] uppercase ${dark ? "text-ivory/80" : "text-gold"}`}>{c.l}</div>
        </div>
      ))}
    </div>
  );
};

export default Countdown;
